(function () {
  "use strict";

  xlsAutoMapper.$inject = ['xlsConsts', '$rootScope'];
  angular
    .module('trainerWebApp.services')
    .factory('xlsAutoMapper', xlsAutoMapper);

  function xlsAutoMapper(xlsConsts, $rootScope) {

    var first = xlsConsts.firstFieldId;
    var last = xlsConsts.lastFieldId;
    var email = xlsConsts.emailFieldId;
    var username = xlsConsts.usernameFieldId;
    var password = xlsConsts.passwordFieldId;

    var defaultMapping = {
      'first name': first,
      'f_name': first,
      'firstname': first,
      'first': first,
      'name': first,
      'fname': first,
      'last name': last,
      'l_name': last,
      'lastname': last,
      'last': last,
      'surname': last,
      'lname': last,
      'familyname': last,
      'family_name': last,
      'email address': email,
      'email': email,
      'eaddress': email,
      'electronicaddress': email,
      'electronic_address': email,
      'emailaddress': email,
      'email_address': email,
      'username': username,
      'user name': username,
      'user': username,
      'name of user': username,
      'password': password,
      'pass_word': password
    };

    return {
      guessMapping: function (columnNames, fields) {
        var ret = {
          matched: [],
          unmatched: [],
          fields: fields
        };

        var fieldsByName = {};
        var requiredFields = $rootScope.isUsernameEnabled ? [first, last] : [first, last, email];

        _.each(fields, function (field, idx) {
          field.required = !!~requiredFields.indexOf(field.id);

          var name = field.name.toLowerCase();
          fieldsByName[name] = fieldsByName[name] || field.id;
        });

        for (var colIdx = 0, c = columnNames.length; colIdx < c; colIdx++) {
          var name = columnNames[colIdx].trim();
          var lcName = name.toLowerCase();

          var guess = defaultMapping[lcName] || fieldsByName[lcName];
          var matchedField = _.find(fields, function (field) {
            return field.id && field.id === guess && field.columnIdx === null;
          });

          if (matchedField) {
            matchedField.columnIdx = colIdx;
          } else {
            ret.unmatched.push({idx: colIdx, name: name});
          }
        }

        _.each(fields, function (field) {
          if (field.columnIdx != null) {
            ret.matched.push({idx: field.columnIdx, name: columnNames[field.columnIdx]});
          } else {
            ret.matched.push({placeHolder: true});
          }

        });

        return ret;
      },

      requiredFieldsMapped: function (matchedFields, userFields) {
        var find = this.findRequiredMissed(matchedFields, userFields);
        return find.required && find.optional;
      },

      findRequiredMissed: function (matchedFields, userFields) {
        var ret = {
          required: false,
          optional: true
        };

        if (!matchedFields.length || !userFields.length)
          return ret;

        var mainRequiredMapped = true;
        for (var i = 0, c = userFields.length; i < c; i++) {
          if (userFields[i].required && matchedFields[i].placeHolder) {
            mainRequiredMapped = false;
          }
        }

        if (!$rootScope.isUsernameEnabled) {
          ret.required = mainRequiredMapped;
          return ret;
        }

        var optionalRequiredMapped = true;

        if (matchedFields[xlsConsts.emailIdx].placeHolder &&
          (matchedFields[xlsConsts.usernameIdx].placeHolder ||
          matchedFields[xlsConsts.passwordIdx].placeHolder)) {
          optionalRequiredMapped = false;
        }

        ret.required = mainRequiredMapped;
        ret.optional = optionalRequiredMapped;

        return ret;
      }
    };

  }

})();
